<template>
  <div class="combn_cup">
    <img :src="bannerPic" width="100%" alt="">
  </div>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
import IMGGROUPS from '@/common/util/imgBus';
export default {
  data() {
    return {
      bannerPic: IMGGROUPS.product.banner,
      bannerHight: 500,
      productBannerList: []
    };
  },
  created() {
    this.getBanner();
  },
  methods: {
    getBanner() {
      // banner图片获取
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 1 }).then(res => {
        let tempBnnerArr = res.data.records;
        for (let i = 0; i < tempBnnerArr.length; i++) {
          // const element = tempBnnerArr[i];
          let banObj = { path: '', title: '' };
          if (tempBnnerArr[i].commonImg) {
            banObj.path = tempBnnerArr[i].commonImg;
            banObj.title = tempBnnerArr[i].commonId;
            this.productBannerList.push(banObj);
          } else {
            continue;
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.combn_cup {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/product/productBanner.vue